import React, { useState } from 'react';
import './App.css';
import Layout from './components/Layout';
import Intro from './components/Intro';
import Projects from './components/Projects';
import Experience from './components/Experience';
import Contact from './components/Contact';
import Coffee from './components/Coffee';
import UnderConstruction from './components/UnderConstruction';

function App() {
  const [activeTab, setActiveTab] = useState('home');

  const renderContent = () => {
    switch (activeTab) {
      case 'home':
        return <Intro />;
      case 'projects':
        return <Projects />;
      case 'experience':
        return <Experience />;
      case 'coffee':
        return <Coffee />;
      case 'contact':
        return <Contact />;
      case 'construction':
        return <UnderConstruction />;
      default:
        return <Intro />;
    }
  };

  return (
    <Layout activeTab={activeTab} onTabChange={setActiveTab}>
      <div className="fade-in">
        {renderContent()}
      </div>
    </Layout>
  );
}

export default App;
